export default "__VITE_ASSET__BcQRRJS9__"